import { PropsWithChildren } from "react";
import { Flex } from "@radix-ui/themes";

interface InnerContentLayoutProps {
  className?: string;
}

export function InnerContentLayout({
  children,
  className,
}: PropsWithChildren<InnerContentLayoutProps>) {
  return (
    <Flex
      direction="column"
      gap="4"
      p="6"
      width="100%"
      height="100%"
      align="start"
      justify="start"
      className={className}
    >
      {children}
    </Flex>
  );
}
